import React from 'react'
import {
    MuiTypography, MuiGrid,
    MuiTableCell, MuiTableBody, MuiTableRow,
} from '../../ui/MaterialUIComponents'
import theme from '../../../assests/theme'
import moment from 'moment';
import {itemName,statusText} from './OrderConstants'

export default function OrderListItemComponent(props) {

    function getTableCell() {
        let rowArray = []
        for (let i = 0; i < props.orderHistory.length; i++) {
            let order = props.orderHistory[i]
            let passthrough = JSON.parse(order.passthrough)
            let cellArray = []
            cellArray.push(<MuiTableCell align="center">
                <MuiGrid container direction='column'>
                    <MuiGrid item xs>
                        {moment(order.created_at).format('MM-DD-YYYY')}
                    </MuiGrid>
                </MuiGrid>
            </MuiTableCell>
            )
            cellArray.push(<MuiTableCell align="center">
                <MuiGrid container direction='column'>
                    <MuiGrid item xs>
                        <MuiTypography style={theme.typography.body1} display="block" gutterBottom>
                            {order.order_id}
                        </MuiTypography>
                    </MuiGrid>
                </MuiGrid>
            </MuiTableCell>
            )

            // cellArray.push(<MuiTableCell align="center">
            //     <MuiGrid container direction='column'>
            //         <MuiGrid item xs>
            //             <MuiTypography style={theme.typography.body1} display="block" gutterBottom>
            //                 {passthrough.schoolId}
            //             </MuiTypography>
            //         </MuiGrid>
            //     </MuiGrid>
            // </MuiTableCell>
            // )
            cellArray.push(<MuiTableCell align="center">
                <MuiGrid container direction='column'>
                    <MuiGrid item xs>
                        <MuiTypography style={theme.typography.body1} display="block" gutterBottom>
                            {itemName(order.product_id)}
                        </MuiTypography>
                    </MuiGrid>
                </MuiGrid>
            </MuiTableCell>
            )

            cellArray.push(<MuiTableCell align="center">
                <MuiGrid container direction='column'>
                    <MuiGrid container direction='column'>
                        <MuiGrid item xs>
                            <MuiTypography style={theme.typography.body1} display="block" gutterBottom>
                                {order.amount}
                            </MuiTypography>
                        </MuiGrid>
                    </MuiGrid>
                </MuiGrid>
            </MuiTableCell>)

            cellArray.push(<MuiTableCell align="center">
                <MuiGrid container direction='column'>
                    <MuiGrid container direction='column'>
                        <MuiGrid item xs>
                            <MuiTypography style={theme.typography.body1} display="block" gutterBottom>
                                {statusText(order.status)}
                            </MuiTypography>
                        </MuiGrid>
                    </MuiGrid>
                </MuiGrid>
            </MuiTableCell>)
            cellArray.push(<MuiTableCell align="center">
                <MuiGrid container direction='column'>
                    <MuiGrid container direction='column'>
                        <MuiGrid item xs>
                            <MuiTypography style={theme.typography.body1} display="block" gutterBottom>
                                <a href={order.receipt_url} style={{cursor:'pointer',textDecoration:'none'}} target="_blank">
                                {props.i18n.orderHistory.receipt}
                                    </a>
                            </MuiTypography>
                        </MuiGrid>
                    </MuiGrid>
                </MuiGrid>
            </MuiTableCell>)

            let row = <MuiTableRow hover>{cellArray}</MuiTableRow>
            rowArray.push(row);
        }
        return rowArray;
    }

    return (
        <MuiTableBody>
            {getTableCell()}
        </MuiTableBody>
    )
}

